import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState, type ReactNode } from "react";
import { SessionExpiredError } from "@/shared/api";

/**
 * TanStack Query provider.
 *
 * Retry policy is the interesting part: a 401 from IAP means "go and sign in",
 * so retrying it just delays the reload by three round trips.
 */
export function QueryProvider({ children }: { children: ReactNode }) {
  // Created in state, not at module scope, so StrictMode's double render and
  // any future test render each get their own cache.
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: (failureCount, error) =>
              !(error instanceof SessionExpiredError) && failureCount < 2,
            staleTime: 30_000,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
